<template>
  <div class="sign-success">
    <van-image
      class="mb20"
      width="160"
      height="128"
      :src="require('@/assets/images/income/sign-success.png')"
    />
    <p>免密授权签约成功。快去创建您的专属直播吧~</p>
  </div>
</template>

<script>
export default {
  name: 'SignSuccess'
}
</script>

<style lang="scss" scoped>
.sign-success {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 100px;
}
</style>
